// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__o2pEC","col":"styles_col__OnlAe","fulfillmentStatus":"styles_fulfillmentStatus__37Ojc","emailCol":"styles_emailCol__3aJYl"};